import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { StoreModule } from '@ngrx/store'

import { UIModule } from '@ui/ui.module'

import { DeviceTokenRemoveComponent } from './components/device-token-remove/device-token-remove.component'
import { DeviceTokensListComponent } from './components/device-tokens-list/device-tokens-list.component'
import { PermissionsBlockedComponent } from './components/permissions-blocked/permissions-blocked.component'
import { PushNotificationsRequestComponent } from './components/push-notifications-request/push-notifications-request.component'
import { featureKey, reducer } from './ngrx'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(featureKey, reducer),
    UIModule,
    PushNotificationsRequestComponent,
    DeviceTokensListComponent,
    DeviceTokenRemoveComponent,
    PermissionsBlockedComponent,
  ],
})
export class PushNotificationsModule {}
